export const transformInfoBannerDto = infoBanner => ({
  level: infoBanner.level,
  title: infoBanner.title || undefined,
  body: infoBanner.body,
  screenName: infoBanner.screen_name,
  extraNotice: !!infoBanner.extra_notice
});